import { Component, Input } from "@angular/core";
import { ItemStatus } from "src/services/item/item.interface";
import { camelCaseToDisplayString, generateRandomString } from "src/services/utils/string.utils";

@Component({
  selector: "rc-item-status-icon",
  templateUrl: "./item-status-icon.component.html",
  styleUrls: ["./item-status-icon.component.scss"],
  standalone: false,
})
export class ItemStatusIconComponent {
  @Input() public itemStatus: ItemStatus;

  public randomId = generateRandomString();

  constructor() {}

  public isUnknownItemStatus(): boolean {
    return (
      this.itemStatus !== "inStaging" &&
      this.itemStatus !== "inStorage" &&
      this.itemStatus !== "inTrip" &&
      this.itemStatus !== "inVehicle" &&
      this.itemStatus !== "onboarding" &&
      this.itemStatus !== "reclaimed"
    );
  }

  public readonly camelCaseToDisplayString = camelCaseToDisplayString;
}
